import React from 'react';
import Logo from './Logo';

const Header = ({ isOnboarding }) => {
  if (isOnboarding) {
    return (
      <header className="fixed top-0 left-0 right-0 bg-white/20 backdrop-blur-sm z-50 border-b border-white/30">
        <div className="max-w-6xl mx-auto px-6 py-5 flex justify-between items-center">
          <Logo size="md" />
        </div>
      </header>
    );
  }

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/20 backdrop-blur-sm z-50 border-b border-white/30">
      <div className="max-w-6xl mx-auto px-6 py-5 flex justify-between items-center">
        <Logo size="md" />
        <a
          href="https://play.google.com/store/apps/details?id=zm.co.wako"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 bg-rose text-white text-sm rounded-full hover:bg-charcoal transition-colors duration-300"
        >
          Download
        </a>
      </div>
    </header>
  );
};

export default Header;